import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { EmployNumListType } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { createInitialEmployNumList } from '../../logics/employNum/createInitialEmployNumList';

/**
 * 従業員数に関するhooks
 * @param args
 * @returns 表示用配列と更新処理
 */
export const useEmployeeNum = (args: HooksArgument) => {
  const [employNumList, setEmployNumList] = useState<EmployNumListType[]>(
    createInitialEmployNumList(args)
  );

  const selectedEmployNumList = useMemo(() => {
    return employNumList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  }, [employNumList]);

  // チェック状態更新処理
  const updateIsCheckedEmployNumList = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const checkedList = employNumList.map((item) => {
        if (item.value !== event.target.value) return item;

        return {
          ...item,
          isChecked: event.target.checked,
        };
      });

      setEmployNumList(checkedList);

      return checkedList
        .filter(({ isChecked }) => isChecked)
        .map(({ value }) => value);
    },
    [employNumList]
  );

  // 求人件数更新処理
  const updateEmployNumListJobCount = useCallback(
    (requirementsJobCountList: JobCountDetailResponse[] | undefined) => {
      setEmployNumList((pre) =>
        pre.map((item) => ({
          ...item,
          jobCount: findJobCount(requirementsJobCountList, item.value),
        }))
      );
    },
    []
  );

  return {
    employNumList,
    selectedEmployNumList,
    updateIsCheckedEmployNumList,
    updateEmployNumListJobCount,
  };
};
